<td class="dr-table-cell dr-table-cell--status-{{item.status}}">
  <div class="badge-wrapper">
    <ion-badge class="item-badge" [style.--background]="item.organization?.indicatorColor || 'var(--skeleton-color)'"></ion-badge>
  </div>
  @if (organizationDetailPath) {
    <span class="skeleton">
      <a class="organization-link"
        [routerLink]="organizationDetailPath"
        (click)="onOrganizationNameClicked($event)">
        {{ item.organizationName }}
      </a>
    </span>
  } @else {
    <span class="skeleton">{{ item.organizationName }}</span>
  }
</td>
<td class="dr-table-cell">
  @if (item.organizationType) {
    <span class="skeleton">
      {{ item.organizationType | translate }}
    </span>
  } @else {
    -
  }
</td>
<td class="dr-table-cell">
  <span class="skeleton">{{ item?.updatedAt | date: 'dd.MM.YYYY HH:mm' }}</span>
</td>
<td class="dr-table-cell">
  <span class="skeleton">{{ item.editor }}</span>
</td>
<td class="dr-table-cell">
  @if (item.status) {
    <div class="skeleton dr-table-badge dr-table-badge--status-{{item.status}}">
      <ion-icon class="dr-table-badge__icon" [name]="item.statusIcon"></ion-icon>
      <span>{{ ('TERM.DATA_REVIEW_STATUS.' + item.status.toUpperCase()) | translate }}</span>
    </div>
  } @else {
    -
  }
</td>
